@defer (on immediate) {
  <section resource-hero [slides]="heroSlides"></section>
} @placeholder {
  <section class="vw-100 vh-100"></section>
}
<section
  jump-to
  [jumpToData]="jumpToData"
  [activeSection]="jumpToData[0].buttonFragment"
  [mobileWrap]="true"
  [reorderMobile]="false"
  [wrapIndex]="1"
></section>
<section callouts></section>
<section cards></section>
<section about-the-survey class="mx-auto"></section>
<section references class="mx-auto"></section>
<review-bar [isUpdated]="false" [dateText]="'in August 2026'"></review-bar>
